const cal202007 = require('./202007.json');
const cal202008 = require('./202008.json');

const calendariotributario = [...cal202007, ...cal202008];

export default calendariotributario;
